import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

export const ActiveUserFilterSlice = createSlice({
  name: "ActiveUserFilter",
  initialState: {} as IReduxState<any>,
  reducers: {
    ActiveUserFilter: (state,_: PayloadAction<any>) => {
      state.isLoading = true;
    },
    successActiveUserFilter: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureActiveUserFilter: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearActiveUserFilter: (state) => {
      state.data = {};
    },
  },
});

export const {
  failureActiveUserFilter,
  successActiveUserFilter,
  clearActiveUserFilter,
  ActiveUserFilter,
} = ActiveUserFilterSlice.actions;

export default ActiveUserFilterSlice.reducer;
